import styled from "styled-components"

import { Bounds, Box } from "../grid"
import { BaseContainer } from "../container"
import { devices, colors } from "../../utils/styleVariables"
import { setColor } from "../../utils/styleFunctions"

const FeatureContainer = styled(BaseContainer)`
  @media ${devices.laptop} {
    background: ${props =>
      props.background ? `url(${props.background})` : "none"};
    background-repeat: no-repeat;
    background-position: center center;
  }

  .slick-slider {
    max-width: 600px;
    width: 80%;
    margin: 0 auto;
  }
  .text {
    @media ${devices.tablet} {
      width: 60%;
      margin-left: auto;
      margin-right: auto;
    }
  }
`

const FeatureCTA = styled(Bounds)`
  flex-direction: column;
  align-items: center;

  div {
    text-align: center;
  }
  button {
    margin-top: 20px;
  }
`

const ListContainer = styled(Bounds)`
  flex-wrap: wrap;
`

const ListItem = styled(Box)`
  width: ${props => props.widths[0]};
  padding: 24px 8px;

  @media ${devices.mobile} {
    width: ${props => props.widths[1]};
  }

  @media ${devices.tablet} {
    padding: 64px 8px;
    width: ${props => props.widths[2]};
  }

  @media ${devices.laptop} {
    width: ${props => props.widths[3]};
  }

  @media ${devices.monitor} {
    width: ${props => props.widths[4]};
  }
`

const ListFlex = styled(Bounds)`
  width: 70%;
  margin: 0 auto;
  align-items: center;
  justify-content: space-between;
  flex-flow: ${props => (props.premium ? "column" : "row")};
  @media ${devices.tablet} {
    width: 100%;
    margin: auto;
    flex-flow: column;
  }

  & h3 {
    margin-bottom: 0px;
    text-align: center;

    @media ${devices.tablet} {
      margin-bottom: 1.45rem;
    }
  }

  & .list-title {
    text-align: center;
    text-decoration: none;
  }

  & .more {
    color: ${setColor(colors.coral)};
  }
`

export { FeatureContainer, FeatureCTA, ListContainer, ListItem, ListFlex }
